module.exports = __webpack_public_path__ + "static/media/конвеєрна-зерносушарка.68fcdb50.jpg";